import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, FadeIn } from "./Reveal";
import { GROUPS as GROUP_DATA } from "@/data/groups";

const GROUPS = GROUP_DATA.map((g) => ({
  slug: g.slug,
  tag: g.tag,
  title: g.title,
  copy: g.short,
  image: g.heroImage,
  span:
    g.slug === "hen-stag"
      ? "lg:col-span-2 lg:row-span-2 min-h-[440px] lg:min-h-[560px]"
      : g.slug === "families"
        ? "lg:col-span-2 min-h-[300px]"
        : "min-h-[300px]",
}));

function GroupCard({ group, index }) {
  return (
    <FadeIn delay={index * 0.08} className={`h-full ${group.span}`}>
      <Link
        to={`/groups/${group.slug}`}
        data-testid={`group-card-${index + 1}`}
        className="group relative block h-full w-full min-h-[300px] overflow-hidden border border-white/5"
      >
        <img
          src={group.image}
          alt={group.title}
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/45 to-navy-950/10 transition-opacity duration-500" />
        <div className="absolute inset-x-0 bottom-0 p-7 sm:p-9">
          <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">{group.tag}</span>
          <h3 className="mt-3 font-serif text-3xl text-ivory sm:text-4xl">{group.title}</h3>
          <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-ivory/75 opacity-0 transition-all duration-500 group-hover:opacity-100 sm:line-clamp-3">
            {group.copy}
          </p>
          <span className="mt-4 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
            Discover
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1.5" />
          </span>
        </div>
      </Link>
    </FadeIn>
  );
}

export default function Groups() {
  return (
    <section id="groups" className="bg-navy-700 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Eyebrow>Group Adventures</Eyebrow>
        <div className="mt-6 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <FadeIn delay={0.1}>
            <h2 className="max-w-xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
              Calling everyone <em className="italic text-gold">together</em>
            </h2>
          </FadeIn>
          <FadeIn delay={0.2}>
            <p className="max-w-md text-sm font-light leading-relaxed text-mist sm:text-base">
              There's simply nowhere better to get together &mdash; for fun, fitness and
              feel-good games. Every package is personalised, every activity fully coordinated.
            </p>
          </FadeIn>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {GROUPS.map((g, i) => (
            <GroupCard key={g.title} group={g} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
